/**
 * AboutSection Component
 * Design: "Light with Dark Accents"
 * Light background (#F8F9FC), blue accents, charcoal text
 * No scroll animations – content always fully visible
 */
import { useLanguage } from "@/contexts/LanguageContext";
import { Target, Zap, TrendingUp } from "lucide-react";

const approachIcons = [Target, Zap, TrendingUp, Target, Zap];

export default function AboutSection() {
  const { t } = useLanguage();

  return (
    <section id="about" className="pt-24 pb-12 lg:pt-32 lg:pb-16 relative overflow-hidden" style={{ background: "#F8F9FC" }}>
      {/* Subtle background accent */}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div>
            <span className="text-blue-600 text-sm font-semibold tracking-widest uppercase mb-4 block font-sora">{t.about.sectionLabel}</span>

            <h2 className="font-sora font-black text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-tight mb-6">
              {t.about.headline.split("\n")[0]}<br />
              <span className="text-blue-600">{t.about.headline.split("\n")[1]}</span>
            </h2>

            <p className="text-slate-800 text-lg leading-relaxed mb-8 font-inter">
              {t.about.text1}
            </p>

            <p className="text-slate-700 leading-relaxed mb-10 font-inter">
              {t.about.text2}
            </p>

            <div className="space-y-3">
              {t.about.approach.map((label, i) => {
                const Icon = approachIcons[i] || Target;
                return (
                  <div
                    key={i}
                    className="flex items-center gap-3 bg-white border border-slate-200 rounded-xl px-4 py-3 shadow-sm hover:shadow-md hover:border-blue-200 transition-all duration-200"
                  >
                    <Icon size={16} className="text-blue-600 flex-shrink-0" />
                    <span className="text-slate-800 font-sora font-semibold text-sm">{label}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
